module.exports = __webpack_public_path__ + "img/8.f43b764.png";